<template>
  <div class="shoppingCart">
    <span class="overview">購物車 ( {{ totalNum }} )</span>
    <div class="desktop-only hidden mt-4">
      <v-divider></v-divider>
      <v-row class="text-center">
        <v-col class="flex-grow-0 mr-4">
          <v-checkbox dense color="pink" :input-value="isAllSelected" @click="selectAll"></v-checkbox>
        </v-col>
        <v-col class="text-left">商品</v-col>
        <v-col cols="4">桃子</v-col>
      </v-row>
      <v-divider></v-divider>
      <v-icon v-if="isEmpty" class="d-block my-6 text-center material-icons-outlined">local_mall</v-icon>
      <v-divider class="mt-1 mb-3"></v-divider>
      <div class="mt-6" v-for="cart in products">
        <div class="d-flex align-center py-1 pointer" @click="$router.push(`/seller/${cart.seller.id}`)">
          <v-avatar size="25" class="mr-2">
            <v-img :src="$HOST_URL + cart.seller.usericon"/>
          </v-avatar>
          <div>{{ cart.seller.nickname }}</div>
        </div>
        <v-divider></v-divider>
        <template v-for="cart_order in cart.orders">
          <v-row class="align-center py-1">
            <v-btn x-small icon class="ma-2" style="position: absolute; right: 0; z-index: 1000" @click="deleteProduct(cart_order.product.id)">
              <v-icon x-small>fa-times</v-icon>
            </v-btn>
            <div class="soldOut" v-if="cart_order.product.sold > 0 || cart_order.product.shelf == 0">售罄</div>
            <div :class="['d-flex align-center', {sold: cart_order.product.sold > 0 || cart_order.product.shelf == 0}]" style="width: 100%">
              <v-col class="flex-grow-0 mr-4" style="min-width: 56px;">
                <v-checkbox dense color="pink" v-model="cart_order.selected" v-if="cart_order.product.sold == 0 && cart_order.product.shelf > 0"></v-checkbox>
              </v-col>
              <v-col class="d-flex align-center">
                <v-img 
                  :src="$func.productImagePreview(cart_order.product)" 
                  aspect-ratio="1"
                  width="50"
                  max-width="50"
                  class="mr-4 pointer"
                  @click="$router.push(`/product/${cart_order.product.id}`)"
                ></v-img>
                <router-link :to="`/product/${cart_order.product.id}`">{{ cart_order.product.title }}</router-link>
              </v-col>
              <v-col cols="4" class="d-flex justify-center align-center">
                <div class="peach"></div>
                {{ cart_order.product.price }}
              </v-col>
            </div>
          </v-row>
          <v-divider></v-divider>
        </template>
      </div>
    </div>

    <div class="mobile-only tablet-only hidden">
      <v-icon v-if="isEmpty" class="d-block my-6 text-center material-icons-outlined">shopping_bag</v-icon>
      <v-divider class="mt-1 mb-3"></v-divider>
      <v-card class="pa-4 my-4" elevation="1" v-for="cart in products">
        <div class="d-flex align-center">
          <v-avatar size="20" class="mr-1">
            <v-img :src="$HOST_URL + cart.seller.usericon"/>
          </v-avatar>
          <div>{{ cart.seller.nickname }}</div>
        </div>
        <v-divider class="mt-1 mb-3"></v-divider>
        <template v-for="(cart_order, i) in cart.orders" >
          <div class="d-flex align-center justify-center flex-column"style="position: relative;">
            <v-btn x-small icon style="position: absolute; top: 0; right: 0; z-index: 1" @click.capture="deleteProduct(cart_order.product.id)">
              <v-icon style="font-size: 10px">fa-times</v-icon>
            </v-btn>
            <div class="soldOut" v-if="cart_order.product.sold > 0 || cart_order.product.shelf == 0">售罄</div>
            <div style="width: 100%" :class="{sold: cart_order.product.sold > 0 || cart_order.product.shelf == 0}">
              <router-link :to="`/product/${cart_order.product.id}`" class="pr-6">
                <v-img 
                  :src="$func.productImagePreview(cart_order.product)" 
                  aspect-ratio="1"
                  width="50"
                  max-width="50"
                  class="mr-3"
                  @click="$router.push(`/product/${cart_order.product.id}`)"
                ></v-img>
                {{ cart_order.product.title }}
              </router-link>
              <div class="d-flex align-center justify-end">
                <div class="peach"></div>
                {{ cart_order.product.price }}
              </div>
            </div>
          </div>
          <v-divider class="my-3" v-if="cart.orders.length - 1 != i"></v-divider>
        </template>
      </v-card>
    </div>

    <div class="cart-detail">
      <div class="amount">
        <div>
          <span>商品</span>
          <span class="d-flex align-center">
            {{ selectedPrice }}
          </span>
        </div>
        <div>
          <span>運費</span>
          <span class="d-flex align-center">
            待計算
          </span>
        </div>
        <div class="total">
          <span>合計</span>
          <span class="d-flex align-center">
            <div class="peach"></div>
            {{ selectedPrice }}
          </span>
        </div>
      </div>
      <div class="cart-action justify-end">
        <v-btn color="black white--text " :disabled="totalNumOfSelectedProducts == 0" @click="nextStep">下一步</v-btn>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
export default {
  mounted() {
    this.$store.dispatch('shoppingCart/getShoppingCartProducts')
  },
  computed: {
    ...mapState('user', ['user']),
    ...mapState('shoppingCart', ['products']),
    ...mapGetters('shoppingCart', ['totalNum', 'totalNumOfSelectedProducts', 'selectedPrice', 'isAllSelected', 
      'selectedProductsId', 'isEmpty'])
  },
  methods: {
    selectAll() {
      if(this.isAllSelected) {
        this.products.forEach(cart => {
          cart.orders.forEach(cart_order => {
            cart_order.selected = false
          })
        })
      }
      else {
        this.products.forEach(cart => {
          cart.orders.forEach(cart_order => {
            cart_order.selected = cart_order.product.sold == 0 && cart_order.product.shelf > 0 ? true : false
          })
        })
      }
    },
    deleteProduct(id) {
      this.axios.delete('/member/cart', { data: {
        product_id: id
      }}).then(response => {
        this.$store.dispatch('shoppingCart/getShoppingCartProducts')
      })
    },
    nextStep() {
      if(this.user.peach < this.selectedPrice) {
        this.$root.$emit('errorDialog', ['桃子不足，請先', {action: () => this.$root.$emit('peachList'), text: '進行充值'}, '。'])
        return
      }
      this.axios.post('/member/checkout/pending', {
        products_id: this.selectedProductsId,
      }).then(response => {
        this.$router.push('/shoppingcart/payment')
      })
      this.axios.get('/member/map/clear')
    }
  }
}
</script>

<style lang="scss" scoped>
.shoppingCart {
  .v-input--checkbox {
    margin-top: 0;
    padding-top: 0;
    .v-input__slot {
      margin-bottom: 0;
    }
  }
  .v-messages {
    display: none;
  }
  .v-card {
    font-size: 14px;
  }
  .row {
    position: relative;
    justify-content: center;
  }
}
</style>